// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownToggleController from "./dropdown_toggle_controller"
application.register("dropdown-toggle", DropdownToggleController)

import FancyboxController from "./fancybox_controller"
application.register("fancybox", FancyboxController)

import FriendlyCaptchaController from "./friendly_captcha_controller"
application.register("friendly-captcha", FriendlyCaptchaController)

import GtmController from "./gtm_controller"
application.register("gtm", GtmController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)
